import type { Supplier } from "../my-type";
import { authUserData } from ".";
import {
  SupplierService as GeneratedSupplierService,
  callApi,
  configureApiClient,
} from "../api/client";

const configureSupplierApiClient = () => {
  configureApiClient({
    tokenProvider: () => authUserData()?.jwtToken ?? null,
  });
};

const mapSupplier = (value: unknown): Supplier => {
  const supplier = value as Supplier;
  return {
    ...supplier,
    createdAt: new Date((supplier as { createdAt?: string | Date }).createdAt ?? Date.now()),
  };
};



/**
 * Get a specific supplier by ID
 * @param supplierId The supplier's unique identifier
 * @returns Supplier object or null if error
 */
export const getSupplierById = async (supplierId: number): Promise<Supplier | null> => {
  try {
    configureSupplierApiClient();
    const data = await callApi(
      () => GeneratedSupplierService.getApiSupplier(supplierId),
      "Failed to fetch supplier"
    );
    return mapSupplier(data);
  } catch (error) {
    console.error("Error fetching supplier by ID:", error);
    return null;
  }
};
